import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import ReactJson from 'react-json-view';
import ReactTooltip from 'react-tooltip';
import miscUtils from '../../utils/miscUtils';

class JsonControl extends Component {
    constructor(props){
        super(props);

        this.onCopy = this.onCopy.bind(this);

        this.state = {
            copySuccess: null
        }
    }

    onCopy() {
        var jsonText = JSON.stringify(this.props.results, '', 4);
        if (jsonText) {
            miscUtils.copyToClipboard(jsonText, document.getElementById('json-wrapper-tab')).then((res) => {
                this.setState({ 
                    copySuccess: true
                }); 
            }).catch((err) => {
                this.setState({ 
                    copySuccess: false
                });   
            });
        }
    }

    render() {   
        return (
            <div className="json-wrapper" id="json-wrapper-tab">
                {this.props.showCopyToClipboard &&
                <div className="json-toolbar">
                    {this.state.copySuccess != null && this.state.copySuccess &&
                        <span>
                            <span className="toolbar-item success fa fa-check-circle" data-tip data-for="success-tip"></span>
                            <ReactTooltip id="success-tip" type="dark" effect="solid" place="top">
                                Copied to clipboard!
                            </ReactTooltip>
                        </span>
                    }
                    {this.state.copySuccess != null && !this.state.copySuccess &&
                        <span>
                            <span className="toolbar-item error fa fa-times-circle" data-tip data-for="error-tip"></span>
                            <ReactTooltip id="error-tip" type="dark" effect="solid" place="top">
                                Error copying to clipboard
                            </ReactTooltip>
                        </span>
                    }
                    <button className="link-button" data-tip data-for="copy-tip" onClick={this.onCopy}><span className="fa fa-copy">&nbsp;</span>Copy</button>
                    <ReactTooltip id="copy-tip" type="dark" effect="solid" place="top">
                        Copy JSON contents to clipboard
                    </ReactTooltip>
                </div>
                }
                <div className={this.props.className ? this.props.className : 'json-display'}>
                    <ReactJson src={this.props.results} 
                        collapsed={3} 
                        collapseStringsAfterLength={30}
                        enableClipboard={false}
                        displayObjectSize={false}
                        displayDataTypes={false}
                        name={false}
                        style={{fontSize: '11px'}}/>
                </div>
            </div>
        );
    }
}

JsonControl.defaultProps = {
    showCopyToClipboard: false,
    className: null
}

JsonControl.propTypes = {
    results: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]).isRequired,
    className: PropTypes.string,
    showCopyToClipboard: PropTypes.bool
};

export default JsonControl;
